import { createSelector } from "@reduxjs/toolkit";

import type { IShopRootState } from "../../../types";
import type { IOrderReducerState } from "../types";

export const orderStateSelector = (state: IShopRootState): IOrderReducerState => state.shopping.order;

// currency selection

const currencySelectionStateSelector = createSelector(orderStateSelector, (state) => state.currencySelection);

export const getCurrencySelectionIsModalOpen = createSelector(currencySelectionStateSelector, (state) => state.isModalOpen);

export const getCurrencySelectionModalCurrentData = createSelector(currencySelectionStateSelector, (state) => ({
  currentCurrency: state.currentCurrency,
  availableCurrencies: state.availableCurrencies
}));
